
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Loader } from "lucide-react";

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  // Bypass authentication check in development mode
  return <>{children}</>;

  // Original authentication code (commented out for now)
  /*
  const { isAuthenticated, isLoading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isLoading && !isAuthenticated) {
      navigate("/");
    }
  }, [isAuthenticated, isLoading, navigate]);

  if (isLoading) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center">
        <Loader className="h-12 w-12 text-[#8CC84B] animate-spin" />
        <p className="mt-4 text-lg">Loading...</p>
      </div>
    );
  }

  return isAuthenticated ? <>{children}</> : null;
  */
};

export default ProtectedRoute;
